<!-- 报销数据操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div v-if="scope.index==0" class="table_content_box">
                <el-form label-width="100px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                  <el-row ref="mainForm" v-if="dataActionBox.actionType != 2">
                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                      <!-- 申请日期 -->
                      <el-date-picker v-if="formOneValue.entityField == 'reiDate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期" style="width: 100%;" value-format="timestamp" :disabled="formOneValue.isChange == 0"></el-date-picker>

                      <!-- 部门 -->
                      <el-tooltip v-else-if="formOneValue.entityField == 'depId'" class="item" :disabled="sendDataInfo.depName==null||sendDataInfo.depName==''?true:false || sendDataInfo.depName.length<=9" effect="dark"
        :content="sendDataInfo.depName" placement="bottom-start">
                      <el-input  @keyup.enter.native="openSearch(formOneValue.searchId, 'depId')" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo.depName" :maxlength="$store.state.inputLength">
                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
                      </el-tooltip>
                      <!-- 申请人	 -->
                      <el-tooltip v-else-if="formOneValue.entityField == 'opmId'" class="item" :disabled="sendDataInfo.opmName==null||sendDataInfo.opmName==''?true:false || sendDataInfo.opmName.length<=9" effect="dark"
        :content="sendDataInfo.opmName" placement="bottom-start">
                      <el-input  @keyup.enter.native="openSearch(formOneValue.searchId, 'opmId')" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo.opmName" :maxlength="$store.state.inputLength">
                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
</el-tooltip>
                      <!-- 原因 -->
                      <el-input clearable v-else-if="formOneValue.entityField == 'reiContent'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" type="textarea"></el-input>
                      <!-- 报销金额 -->
                      <el-input clearable v-else-if="formOneValue.entityField == 'reiMoney'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                      <!-- 备注 -->
                      <el-input clearable v-else-if="formOneValue.entityField == 'reiRemark'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" type="textarea"></el-input>

                      <el-input v-else clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                  </el-row>
                  <el-row ref="mainForm" v-if="dataActionBox.actionType == 2">
                    <el-form-item :label="formOneValue.showField+':'" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []" v-if="formOneValue.isShow==1">
                      <template>
                        <span v-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                        </span>
                        <span v-else-if="formOneValue.entityField == 'purmSdate'">
                            {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                        </span>
                        <span v-else-if="formOneValue.entityField == 'smId'">{{sendDataInfo.smName}}</span>
                        <span v-else-if="formOneValue.entityField == 'opmId'">{{sendDataInfo.opmName}}</span>
                        <span v-else-if="formOneValue.entityField == 'depId'">{{sendDataInfo.depName}}</span>
                        <span v-else-if="formOneValue.entityField == 'isWms'">{{sendDataInfo[formOneValue.entityField] == 0? '否' : '新增'}}</span>
                        <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                      </template>
                    </el-form-item>
                  </el-row>
                </el-form>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foots">
          <el-button v-if="dataActionBox.actionType!=2" type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
        </div>

      </div>
    </div>

    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :parentSearchData="parentSearchData" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
  name: "claimAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      detaislDataInfo: {},
      selectedDataIndex: 0,
      sendDataInfo: {
        depId: "", //	部门
        depName: 0, //	部门
        opmId: "", //	申请人
        reiContent: "", //	报销内容
        reiDate: "", //	申请日期
        reiMoney: "", //	报销金额
        reiRemark: "", //
      },
      showTabs: "",
      formDataList: [],
      DialogVisible: false, //检索
      seId: "",
      seWidth: "",
      seTitle: "",
      seType: "",
      isLoaded: false,
      parentSearchData: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toDetail(orderId) {
      this.$parent.$parent.$parent.toDetail(orderId);
      // this.$emit('toDetail',orderId)
    },

    // 检索Id, 索引(表格中), 标识
    openSearch(sId, type) {
      this.seId = sId;
      this.seType = type;
      this.DialogVisible = true;
      this.parentSearchData[type] = this.sendDataInfo[type];
      if (type == "opmId") {
        this.parentSearchData.opmName = this.sendDataInfo.opmName;
      } else if (type == "depId") {
        this.parentSearchData.depName = this.sendDataInfo.depName;
      }
    },
    //提取返回
    changeInputModel(val) {
      console.log(val);
      if (val != "" || val != undefined) {
        if (this.seType == "opmId") {
          this.sendDataInfo.opmId = val.opmId;
          this.sendDataInfo.opmName = val.opmName;
          this.sendDataInfo.depId = val.depId;
          this.sendDataInfo.depName = val.depName;
        } else if (this.seType == "osmId") {
        }
        this.DialogVisible = false;
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    //确认新增
    sendDataAction(formName1) {
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          // console.log(this.sendDataInfo)
          this.sub();
        } else {
          this.$message({
            message: "请完善必填信息",
            type: "error",
          });
          return false;
        }
      });
    },
    async sub() {
      var responseData;
      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.burseAdd(this.sendDataInfo);
      } else {
        responseData = await this.$http.burseUpdate(this.sendDataInfo);
      }
      if (responseData.status == 200) {
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel");
        // this.dataActionBox.showStatus = false
        // this.$parent.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //取消
    initActionBox(sendDataInfo) {
          this.$emit("drawerCancel");
          // this.$parent.getDataList()
          this.init();
          this.$refs[sendDataInfo].resetFields();
    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "reiDate") {
          this.sendDataInfo[key] = this.$moment().valueOf();
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      this.sendDataInfo["reiMoney"] = 0;
    },
    //父级传入
    openBox(cate, formData, oldData = "") {
      this.showTabs = formData[0].jciName;
      this.formDataList = formData;

      this.init();
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
      } else if (cate == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
      }
      this.dataActionBox.actionType = cate;
      this.dataActionBox.showStatus = true;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      var params = this.actionData;
      this.openBox(params.cate, params.formData, params.oldData);
      this.isLoaded = true;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}
</style>
